module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-7-9526c47d0a6353ba8c67bc1d6c659df1.svg";